import { createContext, useContext } from 'react';
export var VolumeContext = /*#__PURE__*/createContext(undefined);
export var useVolumeContext = function useVolumeContext() {
  var context = useContext(VolumeContext);
  if (context === undefined) {
    throw new Error('useVolumeContext must be used within a VolumeProvider component');
  }
  return context;
};